<template>
  <div class="custom-login-background"></div>
  <div class="custom-login">
    <breeze-validation-errors class="mb-4" />

    <div v-if="status" class="mb-4">
      {{ status }}
    </div>

    <div v-if="showLogo" class="form-floating mb-4 text-center">
      <img src="/media/live/logo.png" alt="Corsync" class="logo" />
    </div>
    <form @submit.prevent="submit" class="custom-login-form">
      <div class="form-floating mb-4 text-center">
        <h4>Login</h4>
      </div>
      <div class="form-floating mb-4">
        <breeze-input
          id="email"
          v-model="form.email"
          type="email"
          class="form-control"
          required
          autofocus
          autocomplete="username"
        />
        <label for="email">Email</label>
      </div>
      <div class="form-floating mb-4">
        <breeze-input
          id="password"
          v-model="form.password"
          type="password"
          class="form-control"
          required
          autocomplete="current-password"
        />
        <label for="password">Password</label>
      </div>
      <!-- <div class="checkbox mb-3 text-center">
        <label class="flex">
          <breeze-checkbox
            name="remember"
            v-model:checked="form.remember"
            class="z-checkbox-small"
          />
          <span class="custom-remember">remember me</span>
        </label>
      </div> -->
      <div class="form-floating mb-4 text-center">
        <breeze-button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
          class="btn btn-primary"
        >
          Log in
        </breeze-button>
      </div>
      <div class="form-floating mb-4 text-center">
        <div class="row">
          <div class="col-12 text-center">
            <inertia-link
              :href="route('password.request')"
              class="btn btn-link text-left"
            >
              <span class="custom-action">forgot password</span>
            </inertia-link>
          </div>
          <!-- <div class="col-6 text-right">
            <inertia-link
              :href="route('register')"
              class="btn btn-link text-right"
            >
              <span class="custom-action">register</span>
            </inertia-link> 
          </div> -->
        </div>
      </div>
    </form>
    <div class="custom-privacy">
      <a
        href="https://sites.google.com/nuvita.com/corsyncpublicpages/privacy-policy"
        target="_blank"
        >Privacy Policy</a
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import BreezeButton from '@/Components/Elements/Button'
import BreezeInput from '@/Components/Elements/Input'
import BreezeCheckbox from '@/Components/Elements/Checkbox'
import BreezeLabel from '@/Components/Elements/Label'
import BreezeValidationErrors from '@/Components/Elements/ValidationErrors'
export default {
  components: {
    BreezeButton,
    BreezeInput,
    BreezeCheckbox,
    BreezeLabel,
    BreezeValidationErrors,
  },
  props: {
    auth: Object,
    canResetPassword: Boolean,
    canRegister: Boolean,
    errors: Object,
    status: String,
    showLogo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
      from: null,
    }
  },
  mounted() {
    this.from = window.sessionData
    console.log('Session Data', window.sessionData)
  },
  methods: {
    ...mapActions('users', ['setToken', 'setProfile', 'clearIntended']),
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          remember: this.form.remember ? 'on' : '',
        }))
        .post(this.route('login'), {
          onSuccess: async (response) => {
            console.log('Logged In', response)
            this.setProfile({
              id: response.props.auth.user.id,
              name: response.props.auth.user.name,
              email: response.props.auth.user.email,
              roles: response.props.auth.roles,
              avatar: response.props.auth.details.avatar,
            })
            let url = route('organizations')
            if (this.from) {
              if (this.from.indexOf('/deleteaccount') > 0) {
                url = route('deleteaccount')
                console.log('Going to delete account')
              }
            } else {
              console.log('Load up State/Provinces, Timezones, Custom Views')
              console.log('Route to Organizations')
            }
            this.clearIntended()
            window.location = url
          },
          onFinish: () => this.form.reset('password'),
        })
      let token = btoa(this.form.email + ':' + this.form.password)
      this.setToken(token)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-privacy {
  position: fixed;
  bottom: 10px;
  left: 10px;
}
.logo {
  height: 48px;
  width: auto;
}
.custom-login-background {
  width: 100%;
  height: 100vh;
  padding: 15px;
  margin: auto;
  background: none;
  background-image: url(/media/live/CorSync-Tech-Wide.PNG);
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.7;
}
.custom-login {
  width: 100%;
  height: 100vh;
  padding: 15px;
  margin: auto;
  background: none;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-login-form {
  background-color: rgb(240, 240, 240);
  // background-color: rgba(255,255,255,0.5);
  color: black;
  border-radius: 5px;
  width: 330px;
  padding: 10px;
  margin: 0 auto;
  margin-top: 25px;
  border: 1px solid rgb(104, 104, 104);
}
.custom-remember {
  margin-left: 5px;
  font-size: 0.9em;
}
.custom-action {
  font-size: 0.8em;
  text-align: center;
}
</style>
